/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1670
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 168 */"./1648/168")
var i = require(/* 309 */"./1771/309")
var a = require(/* 497 */"./1705/497")
var s = require(/* 1088 */"./1700/1088")
r({
  target: "Object",
  stat: true,
  forced: o(function () {
    a(1)
  }),
  sham: !s
}, {
  getPrototypeOf: function (e) {
    return a(i(e))
  }
})
